module.exports = __webpack_public_path__ + "img/amazon.13b92e63.png";